import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import steps from '../../survey/steps';
import s from './index.module.scss';

function ActionBar({ show, currentStepCompleted, questionsType, planMan, stepName }) {
	const { T } = useT();
	const resultPage0day = useSelector(state => state.global.resultPage0day);
	const resultPagePersonolizedPlan = useSelector(state => state.global.resultPagePersonolizedPlan);
	const resultPagePlansTable = useSelector(state => state.global.resultPagePlansTable);
	const configTypeV1 = useSelector((state) => state.steps.config) === 'typeV1';
	const stateClass = show ? s.show : '';
	const currentWeight = questionsType.getAnswers({ questionName: 'weight' });
	const [isLoseWeight, setIsLoseWeight] = useState(false);
	const [isGainMuscles, setIsGainMuscles] = useState(false);
	const [isNotSameWeight, setIsNotSameWeight] = useState(false);

	function forward() {
		if (!currentStepCompleted) return;

		if (!configTypeV1) {
			const goalLoseWeight = questionsType.isAnswerSelected({ questionName: 'goal', answer: 'lose_weight' });
			const goalGainMuscles = questionsType.isAnswerSelected({ questionName: 'goal', answer: 'gain_muscles' });
			const weightAnswer = questionsType.getAnswers({ questionName: 'weight' }).value.value;
			const targetWeightAnswer = questionsType.getAnswers({ questionName: 'target_weight' }).value.value;

			if (goalLoseWeight && !isLoseWeight) {
				questionsType.addOnlyAnswer({
					questionName: 'goal',
					answer: 'lose_weight',
				});
				setIsLoseWeight(true);
			}

			if (
				!planMan &&
				targetWeightAnswer > 29 &&
				weightAnswer !== targetWeightAnswer &&
				!isNotSameWeight &&
				!resultPage0day &&
				!resultPagePersonolizedPlan &&
				!resultPagePlansTable
			) {
				questionsType.addOnlyAnswer({
					questionName: 'body_mass',
					answer: 'notSameWeight',
				});
				setIsNotSameWeight(true);
			}

			if (planMan && goalGainMuscles && !isGainMuscles) {
				questionsType.addOnlyAnswer({
					questionName: 'goal',
					answer: 'gain_muscles',
				});
				setIsGainMuscles(true);
			}

			if (planMan && stepName === 'weight' && goalLoseWeight !== 'lose_weight' && goalGainMuscles !== 'gain_muscles') {
				questionsType.setAnswer({
					questionName: 'target_weight',
					answerName: 'value',
					answerValue: {
						value: currentWeight.value.value,
					},
				});

			}
		}

		steps.navigate.forward({
			preventAction: 500,
		});

		steps.userMovedToNextStepByClick({ byNextStep: false });
	}

	return (
		<div className={`${s.actionBar} ${stateClass} bottomBar`}>
			<button
				className={s.completeButton}
				type="button"
				onClick={forward}
				onTouchStart={forward}
				disabled={!currentStepCompleted}
			>
				{T('continue')}
			</button>
		</div>
	);
}

export default ActionBar;
